import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faCopy,
  faShareNodes,
  faStore,
} from '@fortawesome/free-solid-svg-icons';
import ContentModal from '../UnifiedModal/variants/ContentModal';
import './BotShareModal.css';

interface BotShareModalProps {
  isOpen: boolean;
  isMarketplaceListed: boolean;
  onClose: () => void;
  onCopyPerformanceLink: () => void | Promise<void>;
  onManageMarketplace: () => void;
  onShareStrategy: () => void;
}

export default function BotShareModal({
  isOpen,
  isMarketplaceListed,
  onClose,
  onCopyPerformanceLink,
  onManageMarketplace,
  onShareStrategy,
}: BotShareModalProps) {
  return (
    <ContentModal
      isOpen={isOpen}
      onClose={onClose}
      title="Share bot"
      size="md"
      className="bot-share-modal"
    >
      <div className="bot-share-options">
        <button
          type="button"
          className="bot-share-option"
          onClick={onCopyPerformanceLink}
        >
          <span className="bot-share-option-icon" aria-hidden="true">
            <FontAwesomeIcon icon={faChartLine} />
          </span>
          <span className="bot-share-option-copy">
            <span className="bot-share-option-title">Copy bot performance link</span>
            <span className="bot-share-option-description">
              Share the public performance page without private account details.
            </span>
          </span>
          <FontAwesomeIcon className="bot-share-option-action" icon={faCopy} aria-hidden="true" />
        </button>

        <button
          type="button"
          className="bot-share-option"
          onClick={onShareStrategy}
        >
          <span className="bot-share-option-icon" aria-hidden="true">
            <FontAwesomeIcon icon={faShareNodes} />
          </span>
          <span className="bot-share-option-copy">
            <span className="bot-share-option-title">Share backing strategy</span>
            <span className="bot-share-option-description">
              Create a strategy share link or update its visibility.
            </span>
          </span>
        </button>

        <button
          type="button"
          className="bot-share-option"
          onClick={onManageMarketplace}
        >
          <span className="bot-share-option-icon" aria-hidden="true">
            <FontAwesomeIcon icon={faStore} />
          </span>
          <span className="bot-share-option-copy">
            <span className="bot-share-option-title">
              {isMarketplaceListed ? 'Manage Marketplace listing' : 'Publish to Marketplace'}
            </span>
            <span className="bot-share-option-description">
              {isMarketplaceListed
                ? 'Open the listing settings for this strategy.'
                : 'List the backing strategy on the Marketplace.'}
            </span>
          </span>
        </button>
      </div>
    </ContentModal>
  );
}
